export const JOIN_DEMO_STORE_EVENT = "lucis:join-demo-store";
export const DEMO_STORE_MEMBERSHIP_CHANGED_EVENT =
  "lucis:demo-store-membership-changed";

/**
 * Requests demo-store enrollment from the mounted dashboard layout without
 * forcing a route change or full page reload.
 */
export const requestJoinDemoStore = () => {
  if (typeof window === "undefined") {
    return false;
  }

  window.dispatchEvent(new CustomEvent(JOIN_DEMO_STORE_EVENT));
  return true;
};

export const notifyDemoStoreMembershipChanged = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(DEMO_STORE_MEMBERSHIP_CHANGED_EVENT));
};
